import { render, staticRenderFns } from "./BuilderAttachments.vue?vue&type=template&id=3eb57291&scoped=true&"
import script from "./BuilderAttachments.vue?vue&type=script&lang=js&"
export * from "./BuilderAttachments.vue?vue&type=script&lang=js&"
import style0 from "./BuilderAttachments.vue?vue&type=style&index=0&id=3eb57291&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb57291",
  null
  
)

export default component.exports